import styled from 'styled-components';
import { Input } from 'antd';

export const NavTabs = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  flex: 1;
`;

export const NavTab = styled.button`
  padding: 6px 18px;
  border-radius: 6px;
  border: none;
  background: ${props => (props.active ? '#e6f7ff' : 'transparent')};
  color: ${props => (props.active ? '#47A4EA' : '#595959')};
  font-weight: ${props => (props.active ? '500' : '400')};
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: ${props => (props.active ? '#e6f7ff' : '#f5f5f5')};
    color: ${props => (props.active ? '#47A4EA' : '#262626')};
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex: 1;
  border: 1px solid #e1e4eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  min-height: 0;
`;

export const Sidebar = styled.div`
  flex: 0 0 37.5%;
  flex-shrink: 0;
  border-right: 1px solid #e1e4eb;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SidebarHeader = styled.div`
  padding: 14px 16px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8c8c8c;
  border-bottom: 1px solid #e1e4eb;
  flex-shrink: 0;
`;

export const SidebarSearch = styled(Input)`
  margin: 10px 12px;
  width: calc(100% - 24px);
  border-radius: 6px !important;
  font-size: 13px;
`;

export const TemplateListScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 6px 10px;
`;

export const TemplateItem = styled.div`
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${props => (props.selected ? '#91d5ff' : 'transparent')};
  background: ${props => (props.selected ? '#fff' : 'transparent')};
  margin-bottom: 4px;
  transition: all 0.1s;

  &:hover {
    background: #fff;
    border-color: #e1e4eb;
  }
`;

export const TemplateName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 2px;
`;

export const TemplateMeta = styled.div`
  font-size: 11px;
  color: #8c8c8c;
`;

export const NewTemplateBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: calc(100% - 20px);
  margin: 4px 10px 12px;
  padding: 9px 12px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  color: #595959;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    border-color: #47A4EA;
    color: #47A4EA;
    background: #e6f7ff;
  }
`;

export const MainPanel = styled.div`
  flex: 1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyState = styled.div`
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  font-size: 36px;
  margin-bottom: 12px;
`;

export const EmptyStateText = styled.div`
  font-weight: 500;
  color: #595959;
  margin-bottom: 4px;
  font-size: 14px;
`;

export const EmptyStateSubtext = styled.div`
  color: #8c8c8c;
  font-size: 13px;
`;

export const EditorContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const EditorBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 20px;
  border-bottom: 1px solid #e1e4eb;
  background: #fff;
  font-size: 12px;
  color: #8c8c8c;
  flex-shrink: 0;
`;

export const BreadcrumbLink = styled.span`
  color: #47A4EA;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const EditorLayout = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 320px;
  overflow: hidden;
  min-height: 0;
`;

export const EditorMain = styled.div`
  overflow-y: auto;
  background: #fff;
`;

export const EditorRight = styled.div`
  background: #f9fafb;
  border-left: 1px solid #e1e4eb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const EditorActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const EditorBody = styled.div`
  padding: 22px;
`;

export const FieldGroup = styled.div`
  margin-bottom: 14px;
`;

export const FieldLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8c8c8c;
  margin-bottom: 4px;
`;

export const ConfigBar = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px solid #e1e4eb;
  border-radius: 8px;
  margin-bottom: 18px;
`;

export const ConfigItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #595959;
`;

/* ── Section divider ──────────────────────────────────────── */

export const SectionDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 0 14px;

  span {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8c8c8c;
    white-space: nowrap;
  }

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e1e4eb;
  }
`;

/* ── Heading cards ────────────────────────────────────────── */

export const HeadingCard = styled.div`
  border: 1px solid #e1e4eb;
  border-radius: 10px;
  margin-bottom: 8px;
  background: #fff;
  overflow: hidden;
`;

export const HeadingGrip = styled.span`
  display: flex;
  align-items: center;
  color: #bfbfbf;
  cursor: grab;
  flex-shrink: 0;
  padding-right: 2px;

  &:active {
    cursor: grabbing;
  }
`;

export const HeadingHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #f9fafb;
  border-bottom: 1px solid ${props => (props.open ? '#e1e4eb' : 'transparent')};
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s;
`;

export const HeadingTitle = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #262626;
`;

export const HeadingSystemTag = styled.span`
  font-size: 10px;
  padding: 2px 7px;
  border-radius: 20px;
  background: #f0f0f0;
  color: #595959;
  border: 1px solid #e1e4eb;
  font-weight: 500;
  flex-shrink: 0;
`;

export const HeadingChevron = styled.span`
  font-size: 12px;
  color: #8c8c8c;
  transition: transform 0.2s;
  transform: ${props => (props.open ? 'rotate(180deg)' : 'rotate(0deg)')};
  flex-shrink: 0;
`;

export const HeadingBody = styled.div`
  padding: 14px;
  display: ${props => (props.open ? 'block' : 'none')};
`;

export const ToggleGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(3, auto);
  grid-auto-flow: column;
  gap: 6px 18px;
  width: 50%;
  margin-bottom: 14px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #595959;
`;

export const SubLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8c8c8c;
  margin-bottom: 4px;
`;

export const DefaultValueBox = styled.div`
  border: 1px solid #e1e4eb;
  border-radius: 6px;
  padding: 9px 11px;
  font-size: 13px;
  min-height: 44px;
  color: #262626;
  line-height: 1.6;
  margin-bottom: 12px;
  background: #fafafa;
  color: ${props => (props.empty ? '#bfbfbf' : '#262626')};
  font-style: ${props => (props.empty ? 'italic' : 'normal')};

  p {
    margin: 0;
  }
`;

export const HeadingTextArea = styled(Input.TextArea)`
  border-radius: 6px !important;
  font-size: 13px;
  margin-bottom: 12px;
  resize: vertical;
`;

export const AiPromptWrap = styled.div`
  border: 1px solid #91d5ff;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;
`;

export const AiPromptHead = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  background: #e6f7ff;
  border-bottom: 1px solid #91d5ff;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #1d7ec2;
`;

export const AiPromptField = styled(Input.TextArea)`
  border: none;
  border-radius: 0;
  font-size: 13px;
  resize: vertical;

  &.ant-input:focus,
  &.ant-input-focused {
    box-shadow: none;
  }
`;

/* ── K2P right sidebar ────────────────────────────────────── */

export const K2pPanelHeader = styled.div`
  padding: 12px 14px 10px;
  border-bottom: 1px solid #e1e4eb;
  flex-shrink: 0;

  h4 {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8c8c8c;
    margin-bottom: 8px;
  }
`;

export const K2pPanelSearch = styled(Input)`
  border-radius: 6px !important;
  font-size: 12px;
`;

export const K2pPanelScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 10px;
`;

export const K2pSectionLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8c8c8c;
  margin: 8px 0 5px;

  &:first-child {
    margin-top: 0;
  }
`;

export const K2pItem = styled.div`
  background: ${props => (props.inUse ? '#e6f7ff' : '#fff')};
  border: 1px solid ${props => (props.inUse ? '#91d5ff' : '#e1e4eb')};
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 5px;
  transition: all 0.15s;
  cursor: ${props => (props.draggable ? 'grab' : 'default')};

  &:hover {
    border-color: ${props => (props.inUse ? '#47A4EA' : '#d9d9d9')};
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }

  &:active {
    cursor: ${props => (props.draggable ? 'grabbing' : 'default')};
  }
`;

export const K2pItemTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 3px;
`;

export const K2pItemKey = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #262626;
  line-height: 1.3;
`;

export const K2pBadge = styled.span`
  font-size: 10px;
  padding: 1px 7px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
  font-weight: 500;
  background: ${props => (props.variant === 'active' ? '#e6f7ff' : '#fafafa')};
  color: ${props => (props.variant === 'active' ? '#1d7ec2' : '#8c8c8c')};
  border: 1px solid ${props => (props.variant === 'active' ? '#91d5ff' : '#e1e4eb')};
`;

export const K2pItemPhrase = styled.div`
  font-size: 11px;
  color: #8c8c8c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AddHeadingBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  color: #595959;
  cursor: pointer;
  margin-top: 4px;
  transition: all 0.15s;

  &:hover {
    border-color: #47A4EA;
    color: #47A4EA;
    background: #e6f7ff;
  }
`;

/* ── Section Group cards ──────────────────────────────────── */

export const SectionGroupCard = styled.div`
  border: 1px solid #d0e8ff;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #f6fbff;
`;

export const SectionGroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #e8f4ff;
  border-bottom: 1px solid ${props => (props.open ? '#d0e8ff' : 'transparent')};
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s;
`;

export const SectionGroupTitle = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #1677ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SectionGroupBadge = styled.span`
  font-size: 10px;
  font-weight: 500;
  color: #0958d9;
  background: #dbeafe;
  border: 1px solid #93c5fd;
  border-radius: 4px;
  padding: 0 6px;
  line-height: 18px;
  flex-shrink: 0;
`;

export const SectionGroupBody = styled.div`
  padding: ${props => (props.open ? '14px' : '0')};
  display: ${props => (props.open ? 'block' : 'none')};
`;

export const AddGroupHeadingBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 8px;
  border: 1px dashed #91caff;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 12px;
  color: #4096ff;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.15s;

  &:hover {
    border-color: #1677ff;
    color: #1677ff;
    background: #e8f4ff;
  }
`;

/* ── Section type selector ────────────────────────────────── */

export const SectionTypeBar = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  width: fit-content;
  margin-bottom: 14px;
`;

export const SectionTypeBtn = styled.button`
  padding: 4px 16px;
  border: none;
  border-right: 1px solid #d9d9d9;
  background: ${props => (props.active ? '#e6f7ff' : '#fff')};
  color: ${props => (props.active ? '#1677ff' : '#595959')};
  font-weight: ${props => (props.active ? '600' : '400')};
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: ${props => (props.active ? '#e6f7ff' : '#f5f5f5')};
  }
`;

/* ── Option list editor ───────────────────────────────────── */

export const OptionListWrap = styled.div`
  margin-bottom: 14px;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
`;

export const AddOptionBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 12px;
  color: #595959;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 2px;

  &:hover {
    border-color: #47A4EA;
    color: #47A4EA;
    background: #e6f7ff;
  }
`;
